/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { PointFStruct } from './point-fstruct';
import { ShaderType } from './shader-type';

export class ShaderProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ShaderProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsShaderProto(bb: flatbuffers.ByteBuffer, obj?: ShaderProto): ShaderProto {
    return (obj || new ShaderProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsShaderProto(
    bb: flatbuffers.ByteBuffer,
    obj?: ShaderProto,
  ): ShaderProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ShaderProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  typ(): ShaderType {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : ShaderType.LINEAR_GRADIENT;
  }

  p1(obj?: PointFStruct): PointFStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? (obj || new PointFStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  p2(obj?: PointFStruct): PointFStruct | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? (obj || new PointFStruct()).__init(this.bb_pos + offset, this.bb!) : null;
  }

  r(): number {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 0.0;
  }

  colors(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.readInt32(this.bb!.__vector(this.bb_pos + offset) + index * 4) : 0;
  }

  colorsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  colorsArray(): Int32Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset
      ? new Int32Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  positions(index: number): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readFloat32(this.bb!.__vector(this.bb_pos + offset) + index * 4) : 0;
  }

  positionsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  positionsArray(): Float32Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset
      ? new Float32Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  tileMode(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : 0;
  }

  static startShaderProto(builder: flatbuffers.Builder) {
    builder.startObject(7);
  }

  static addTyp(builder: flatbuffers.Builder, typ: ShaderType) {
    builder.addFieldInt8(0, typ, ShaderType.LINEAR_GRADIENT);
  }

  static addP1(builder: flatbuffers.Builder, p1Offset: flatbuffers.Offset) {
    builder.addFieldStruct(1, p1Offset, 0);
  }

  static addP2(builder: flatbuffers.Builder, p2Offset: flatbuffers.Offset) {
    builder.addFieldStruct(2, p2Offset, 0);
  }

  static addR(builder: flatbuffers.Builder, r: number) {
    builder.addFieldFloat32(3, r, 0.0);
  }

  static addColors(builder: flatbuffers.Builder, colorsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, colorsOffset, 0);
  }

  static createColorsVector(
    builder: flatbuffers.Builder,
    data: number[] | Int32Array,
  ): flatbuffers.Offset;
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createColorsVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset;
  static createColorsVector(
    builder: flatbuffers.Builder,
    data: number[] | Int32Array | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt32(data[i]!);
    }
    return builder.endVector();
  }

  static startColorsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addPositions(builder: flatbuffers.Builder, positionsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, positionsOffset, 0);
  }

  static createPositionsVector(
    builder: flatbuffers.Builder,
    data: number[] | Float32Array,
  ): flatbuffers.Offset;
  /**
   * @deprecated This Uint8Array overload will be removed in the future.
   */
  static createPositionsVector(
    builder: flatbuffers.Builder,
    data: number[] | Uint8Array,
  ): flatbuffers.Offset;
  static createPositionsVector(
    builder: flatbuffers.Builder,
    data: number[] | Float32Array | Uint8Array,
  ): flatbuffers.Offset {
    builder.startVector(4, data.length, 4);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addFloat32(data[i]!);
    }
    return builder.endVector();
  }

  static startPositionsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4);
  }

  static addTileMode(builder: flatbuffers.Builder, tileMode: number) {
    builder.addFieldInt8(6, tileMode, 0);
  }

  static endShaderProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }
}
